import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApexCharts from 'react-apexcharts';
import apiInstance from './utils/apiInstance';

const Dashboard = () => {
  const [error, setError] = useState(null);
  const [restaurantsCount, setRestaurantsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState({
    chart: {
      id: 'bar-chart', type: 'bar', toolbar: {
        show: false,
      },
    },
    xaxis: { categories: [] },
    yaxis: {
      labels: {
        show: false,
      },
      tickAmount: 5,
    },
    colors: ['#57cbff'],

  });

  const totalRestaurants = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiInstance.get('/totalRestaurants');
      setRestaurantsCount(response.data.total);
    } catch (error) {
      setError('Failed to load restaurant data.');
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchChartData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiInstance.post('/apexchart');
      const { data, categories } = response.data;
      setChartData([{ name: 'Restaurants', data }]);
      setChartOptions(prevOptions => ({
        ...prevOptions,
        xaxis: { ...prevOptions.xaxis, categories },
      }));
    } catch (error) {
      setError('Error fetching data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    totalRestaurants();
    fetchChartData();
  }, [totalRestaurants, fetchChartData]);

  const loginmessage = localStorage.getItem('loginmessage');
  useEffect(() => {
    if (loginmessage) {
      toast.success('Login successful');
      localStorage.removeItem('loginmessage');
    }
  }, []);

  if (error) {
    return <div>{error}<br />Please try again after some time or check your internet connection.</div>;
  }
  return (
    <div style={{ position: 'relative' }}>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
            <Link to="/restaurantlist">
              <div className="card">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-info shadow-info text-center border-radius-xl mt-n4 position-absolute">
                    <i className="material-icons opacity-10">restaurant</i>
                  </div>
                  <div className="text-end">
                    <h4 style={{ color: 'black' }}>Restaurants</h4>
                    <h4 style={{ color: 'black' }}>{restaurantsCount}</h4>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <ApexCharts
          options={chartOptions}
          series={chartData}
          type="bar"
          height="100%"
          style={{ height: '365px' }}
        />
      </div>


      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 1000,
          }}
        >
          <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;


